import { useRef, useEffect } from 'react';
import mapboxgl from '!mapbox-gl';  // eslint-disable-line import/no-webpack-loader-syntax
import useMap from '@components/operatorLobby/useMap'

export default function WorldMap({ vehicles }) {
    const { mapRef, mapContainerRef } = useMap(vehicles);
    const boundMap = useRef(true);

    useEffect(() => {
        const bounds = new mapboxgl.LngLatBounds();

        vehicles.forEach((vehicle) => {
            const localization = vehicle.localization;
            if(localization) {
                if(localization.longitude && localization.latitude) {
                    const coordinates = new mapboxgl.LngLat(localization.longitude, localization.latitude);
                    bounds.extend(coordinates);
                } else {
                    console.log('No valid coordinates for vehicle', vehicle.id);
                }
            }
        });

        if(bounds.length > 0 && boundMap.current) { // bound the map only the first time
            mapRef.current.fitBounds(bounds, { padding: 50 });
            boundMap.current = false;
        }
        
    }, [vehicles, mapRef]);

    return <div ref={mapContainerRef} className="map-container"></div>;
};
